export function detailsToggle() {
  const jQuery = window.jQuery

  jQuery("body").on("click", function () {
    jQuery(".bef-exposed-form details").removeAttr("open")
  })

  jQuery("body").keyup(function (e) {
    if (e.key === "Escape") {
      jQuery(".bef-exposed-form details").removeAttr("open")
    }
  })
}
